module.exports = "/packs/period1-02dcc4373e177940c9fcf6a28ee5e311.png";